const GET_COMMENTS = "GET_COMMENTS";
const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
const GET_COMMENTS_FAIL = "GET_COMMENTS_FAIL";

const POST_COMMENT = "POST_COMMENT";
const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";

const BASE_ENDPOINT = "/Integration";

const initialValues = {
  loading: false,
  hasError: false,
  data: {
    comments: [],
  },
};

const ticketsComments = (state = initialValues, action) => {
  switch (action.type) {
    case GET_COMMENTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_COMMENTS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          comments: action.payload.data
        },
        loading: false,
      };
    }

    case GET_COMMENTS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case POST_COMMENT: {

      return {
        ...state,
        loading: true,
      }

    }

    case POST_COMMENT_SUCCESS: {

      return {
        ...state,
        loading: false,
      }

    }

    case POST_COMMENT_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    default: {
      return state;
    }
  }
};

export const getComments = (ticketNumber) => {
  return {
    type: GET_COMMENTS,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/Comments/BySupportTicket?TicketNumber=" + ticketNumber,
      },
    },
  };
};

export const newComment = (commentData) => {
  return {
    type: POST_COMMENT,
    payload: {
      request: {
        method: 'POST',
        url: BASE_ENDPOINT + `/SupportTicket/Comment`,
        data: commentData,
        headers: {
          contentType: "multipart/form-data"
        }
      }
    }
  };
};

export default ticketsComments;
